export default __webpack_public_path__ + "static/media/leader-head-bg-mobile.025a5eb6.png";